import React from 'react';
import ReactJson from 'react-json-view';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Card from '@components/Card';
import InputStandard from '@components/InputStandard';
import Button from '@shared/Button';
import P from '@styled/Elements/P';

import Modal from './components/modal';

const Container = styled.div`
  width: 100%;
  max-width: 600px;
  height: 70vh;
  word-break: break-all;
  overflow: scroll;
`;
const FormContainer = styled.form`
  width: 600px;

  input {
    font-size: 16px;
  }
`;

export default function LookupWidget(props) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [mode, setMode] = React.useState('search');

  const [inputValue, setInputValue] = React.useState('');
  const handleChangeInput = e => setInputValue(e);
  const [result, setResult] = React.useState(null);
  const [entity, setEntity] = React.useState(null);
  const handleClose = () => setEntity(null);

  const apiKey = useSelector(state => state.keys.key);

  const onClickSearch = e => {
    setEntity(inputValue);
  };
  const onSubmitForm = e => {
    e.preventDefault()
    onClickSearch()
  }

  return (
    <div>
      <div style={{ maxWidth: '700px', wordBreak: 'break-all' }}>
        <FormContainer onSubmit={onSubmitForm}>
          <InputStandard
            placeholder='Entity ID'
            type='text'
            value={inputValue}
            onChange={handleChangeInput}
          />
        </FormContainer>
        {!isLoading && (
          <Button
            analyticsName='Search for entity'
            color='black'
            onClick={onClickSearch}
          >
            Search
          </Button>
        )}
      </div>
      {entity && <Modal entity={entity} handleClose={handleClose} />}
    </div>
  );
}
